/**
 * La mappa dei tasti come pagina (GI-281): la stessa tabella della finestra
 * che si apre col «?» nel banco, leggibile con calma prima di sedersi.
 *
 * Una vista sola sui dati di `keys.ts`: la finestra e questa pagina non
 * possono dire due cose diverse, perche' leggono lo stesso elenco.
 */
import { useT } from '../i18n/LocaleProvider'
import { BINDINGS, HANDS } from '../keys'

export function Tasti(): JSX.Element {
  const t = useT()
  return (
    <main className="aiuto-tasti">
      <p className="t-read">{t('aiuto.keysIntro')}</p>
      {HANDS.map(([hand, title]) => (
        <section key={hand}>
          <h2>{t(title)}</h2>
          <ul className="motivi">
            {BINDINGS.filter((one) => one.hand === hand).map((one) => (
              <li key={one.keys.join('')}>
                {one.keys.map((key) => (
                  <kbd key={key}>{key}</kbd>
                ))}{' '}
                {t(one.what)}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </main>
  )
}
